<template>
  <m-tooltip
    placement="bottom"
    :mouse-enter-delay=".5"
    :disabled="showsLabel"
  >
    <template #title>
      {{ title }}
    </template>
    <div class="sidebar-icon-tab">
      <div
        role="button"
        tabindex="0"
        :aria-label="title"
        :class="['_tab', 'icon-hover-host', { '-active': active }]"
        @click="emit('click')"
        @keydown.enter="emit('click')"
      >
        <m-icon
          class="_icon"
          :type="icon"
          size="18"
        />
        <span
          v-if="labeled"
          class="_label"
          aria-hidden="true"
        >
          <span class="_label-text">{{ title }}</span>
        </span>
      </div>
      <span
        v-if="badge !== ''"
        class="_badge"
      >{{ badge }}</span>
    </div>
  </m-tooltip>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  labeled: {
    type: Boolean,
    default: false,
  },
  active: {
    type: Boolean,
    default: false,
  },
  badge: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['click']);

const showsLabel = computed(() => props.labeled && props.active);
</script>

<style
  scoped
  lang="scss"
  type="text/scss"
>
  .sidebar-icon-tab {
    position: relative;

    ._tab {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 3.2rem;
      height: 3.2rem;
      padding: 0 .7rem;
      color: $font-color-secondary;
      cursor: pointer;
      border-radius: .8rem;

      ._icon {
        opacity: .7;
      }

      ._label {
        display: grid;
        grid-template-columns: 0fr;
        margin-left: 0;
        opacity: 0;
        transition: grid-template-columns .2s ease-out, margin-left .2s ease-out, opacity .15s ease-out;
      }

      ._label-text {
        min-width: 0;
        overflow: hidden;
        font-size: $font-size-4;
        font-weight: $font-weight-medium;
        white-space: nowrap;
      }

      &:hover,
      &.-active {
        color: $font-color-primary;
        background-color: $sidebar-hover-color;

        ._icon {
          opacity: 1;
        }
      }

      &.-active ._label {
        grid-template-columns: 1fr;
        margin-left: .6rem;
        opacity: 1;
        transition-delay: 0s, 0s, .05s;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      ._tab ._label {
        transition: none;
      }
    }

    ._badge {
      position: absolute;
      top: -.3rem;
      right: -.2rem;
      min-width: 1.4rem;
      height: 1.4rem;
      padding: 0 .3rem;
      font-size: .9rem;
      font-weight: $font-weight-medium;
      line-height: 1.4rem;
      color: white;
      text-align: center;
      pointer-events: none;
      background-color: $error-color;
      border-radius: .7rem;
      box-shadow: 0 0 0 .2rem $side-nav-background-color;
    }
  }
</style>
